import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { EyeIcon, EyeOffIcon } from "lucide-react";
import {useState, FormEvent, useEffect} from "react";
import { useAuthStore } from "@/stores/auth_store";
import { useNavigate, useSearchParams } from "react-router-dom";
import BaseButton from "@/components/common/BaseButton";
import FindPasswordModal from "./FindPasswordModal";
import "./login.css";

export default function LoginPage() {
  const [showPassword, setShowPassword] = useState(false);
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [findPasswordOpen, setFindPasswordOpen] = useState(false);
  const [searchParams] = useSearchParams();

  const { logIn, loading, logInWithWorks } = useAuthStore();
  const navigate = useNavigate();

  const BASE_URL: string = import.meta.env.VITE_ADMIN_URL || "";

  // 버튼 활성화 조건: 아이디와 패스워드 둘 다 입력되어야 함
  const isFormValid = loginId.trim() !== "" && password.trim() !== "";

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!loginId || !password) {
      alert("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    const result = await logIn({ loginId, password});

    if (result.success) {
      navigate("/"); // 메인 페이지로 이동
    } else {
      alert("로그인 실패. 아이디와 비밀번호를 확인해주세요.");
    }
  };

  const handleWorks = () => {
    const Client_ID = 'WbWr1dkuoMllkiORfam5'
    const Redirect_URL = `${BASE_URL}/login`
    const Scope = 'openid profile email'
    const state = 'puddingAdmin'
    const nonce = Math.random().toString(36).substring(2, 15)

    const authUrl = `https://auth.worksmobile.com/oauth2/v2.0/authorize?client_id=${Client_ID}&redirect_uri=${encodeURIComponent(Redirect_URL)}&scope=${encodeURIComponent(Scope)}&response_type=code&state=${state}&nonce=${nonce}`
    window.location.href = authUrl
  }

  // OAuth 콜백 처리
  useEffect(() =>  {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (code && state) {
      const handleOAuthCallback = async () => {
        const worksData = {
          code
        };

        const result = await logInWithWorks(worksData);

        if (result.success) {
          navigate("/");
        } else {
          alert("웍스 로그인 실패");
        }
      };

      handleOAuthCallback();
    }
  }, []);

  return (
    <div className="login-wrapper ">
      <div className="login-header">
        <span>푸딩툰 관리자 로그인</span>
      </div>
      <form onSubmit={handleSubmit} >
        <div className="login-input-wrap login-id-input">
          <span>ID</span>
          <Input
            type="text"
            placeholder="ID"
            className="id-input login-input"
            value={loginId}
            onChange={(e) => setLoginId(e.target.value)}
            disabled={loading}
          />
        </div>
        <div className="login-password-input">
          <span>Password</span>
          <div className="relative flex items-center">
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="password-input login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading}
            />
            <Button
              type="button"
              variant="ghost"
              className="absolute right-0 top-1"
              onClick={() => setShowPassword((prev) => !prev)}
              disabled={loading}
            >
              {showPassword ? (
                <EyeOffIcon className="h-4 w-4" />
              ) : (
                <EyeIcon className="h-4 w-4" />
              )}
            </Button>
          </div>
        </div>
        <div className={'mb-3'}>
          <BaseButton
            type="submit"
            label="로그인"
            height="36px"
            width="100%"
            color={!isFormValid || loading ? 'lightgray' : 'red'}
            disabled={!isFormValid || loading}
            borderRadius="8px"
          />
        </div>
        <BaseButton
          type="button"
          label={loading ? "로그인 중..." : "웍스 로그인"}
          height="36px"
          width="100%"
          color='blue'
          variant={'outline'}
          borderRadius="8px"
          onClick={handleWorks}
        />
        <div className="login-info-wrapper">
          <button
            type="button"
            className="login-find-password"
            onClick={() => setFindPasswordOpen(true)}
          >
            비밀번호 찾기
          </button>
          <span className="login-info ">계정 분실시 플랫폼본부에 문의해주세요</span>
        </div>
      </form>
      <FindPasswordModal open={findPasswordOpen} onClose={() => setFindPasswordOpen(false)} />
    </div>
  )
}